import * as Preact from 'preact'
const { h } = Preact
const styles = require('./index.css')
const img = require('../../../../assets/logos/nrk-sport-logo.svg')

interface IProps {
  class?: string
  rounded?: boolean
}

const NrkSportLogo = (props: IProps) => {
  const { rounded } = props
  const className = `${styles['nrk-sport-logo']}${
    props.class ? ` ${props.class}` : ''
  }`

  if (rounded) {
    return (
      <span class={className}>
        <span class="nrk-sr">NRK Sport</span>
        <img aria-hidden="true" src={img} />
      </span>
    )
  }

  return <span>NRK Sport</span>
}

export { NrkSportLogo }
